export default "__VITE_ASSET__DwkRoeiC__$_?component__"